export default __webpack_public_path__ + "static/media/2015-SP.4d1d5471.jpg";